import React, { useEffect, useRef } from "react";
import * as echarts from "echarts";
import useEmisionesCo2Mes from "../../../hooks/administrador/emisiones/useEmisionesCo2Mes";
import '../../../styles/administrador.css';

const EmisionesCo2Mes = ({ year, mes, token, idAdministrador }) => {
  const chartRef = useRef(null);
  const { data, loading, error } = useEmisionesCo2Mes(year, mes, token, idAdministrador);

  useEffect(() => {
    if (loading || !chartRef.current) return;
    
    if (error || !Array.isArray(data) || data.length === 0) {
      if (chartRef.current) {
        chartRef.current.innerHTML = "<p style='text-align: center; color: black;'>No hay datos disponibles</p>";
      }
      return;
    }

    const chartDom = chartRef.current;
    let myChart = echarts.getInstanceByDom(chartDom);
    if (myChart) myChart.dispose();
    myChart = echarts.init(chartDom);

    const colors = ['#d1dc5a', '#6ac5cb', '#45444e', '#a3b85b', '#3a6b74'];

    const mesesMap = {
        1: "ENE",
        2: "FEB",
        3: "MAR",
        4: "ABR",
        5: "MAY",
        6: "JUN",
        7: "JUL",
        8: "AGO",
        9: "SEP",
        10: "OCT",
        11: "NOV",
        12: "DIC"
    };

    let mesesL = [];
    data.forEach(row => {
        let mesNum = parseInt(row.mes);
        if (!isNaN(mesNum) && !mesesL.includes(mesNum)) {
            mesesL.push(mesNum);
        }
    });

    mesesL.sort((a, b) => a - b);
    let mesesAbreviados = mesesL.map(mes => mesesMap[mes] || mes);

    var seriesData = {};
        data.forEach(row => {
        let mesNum = parseInt(row.mes);
        if (!isNaN(mesNum)) {
             
            let tipoResiduo = row.tipo_residuo === "PLT 2" ? "PLT" : row.tipo_residuo;
    
             
            const totalEmisionesCo2Tn = 
                ((parseFloat(row.emision_co2_combustion) || 0) +
                (parseFloat(row.emision_co2_ch4_kg) || 0) +
                (parseFloat(row.emision_co2_n2o_kg) || 0))/1000;
    
            if (!seriesData[tipoResiduo]) {
                seriesData[tipoResiduo] = new Array(mesesL.length).fill(0);
            }
    
            let mesIndex = mesesL.indexOf(mesNum);
            if (mesIndex !== -1) {
                seriesData[tipoResiduo][mesIndex] += totalEmisionesCo2Tn;
            }
        }
    });

    const order = ['PLT', 'CVT', 'OTR', 'MOT', 'BICI'];

    var series = order.map((codigo, index) => {
        if (seriesData[codigo]) {
            return {
                name: codigo,
                type: 'bar',
                stack: 'total',
                itemStyle: {
                    color: colors[index % colors.length]
                },
                emphasis: {
                    focus: 'series'
                },
                data: seriesData[codigo]
            };
        }
        return {
            name: codigo,
            type: 'bar',
            stack: 'total',
            itemStyle: {
                color: colors[index % colors.length]
            },
            emphasis: {
                focus: 'series'
            },
            data: new Array(mesesL.length).fill(0)
        };
    }).filter(serie => serie !== null);

    const totalEmisiones = Object.values(seriesData).reduce((sum, item) => {
        return sum + item.reduce((s, v) => s + v, 0);
    }, 0);

    var option = {
        title: {
            text: 'Emisiones de CO2 \n ahorradas en Toneladas',
            left: 'center',
            subtext: `TOTAL AHORRADO: ${totalEmisiones.toFixed(2)} Tn`,
            subtextStyle: {
                fontWeight: 'bold',
                fontSize: '12px'
            },
            textStyle: {
                fontSize: 18,
                fontWeight: 'bold'
            }
        },
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            },
            formatter: function(params) {
                let total = params.reduce((sum, p) => sum + p.value, 0);
                return `<b>${params[0].axisValue}</b><br>` +
                    params.map(p => `${p.marker} ${p.seriesName}: <b>${p.value.toFixed(2)} Tn</b>`).join('<br>') +
                    `<br><br><b>Total: ${total.toFixed(2)} Tn</b>`;
            }
        },
        legend: {
            bottom: 0,
            data: order
        },
        grid: {
            left: '3%',
            right: '4%',
            bottom: '15%',
            containLabel: true
        },
        xAxis: {
            type: 'category',
            data: mesesAbreviados,
            axisLabel: {
                interval: 0,
                fontWeight: 'bold'
            }
        },
        yAxis: {
            type: 'value',
            name: 'TN'
        },
        color: colors,
        series: series
    };

    myChart.setOption(option);
    
    const updateChart = () => {
      myChart.resize();
    };
    
    window.addEventListener('resize', updateChart);
    
    return () => {
      window.removeEventListener('resize', updateChart);
      if (myChart && !myChart.isDisposed()) {
        myChart.dispose();
      }
    };
  }, [data, loading, error]);

  if (loading) {
    return <div className="grafica loading">Cargando datos de emisiones CO2...</div>;
  }

  return <div className="grafica" ref={chartRef}></div>;
};

export default EmisionesCo2Mes;